import { put, takeEvery } from 'redux-saga/effects';
import { Actions as Router } from 'router';
import { Service } from 'sections/campaigns/state/services';
import { Types } from 'services/genericAPIGatewayService';
import { Action } from 'store';

function* hideNewIPModal() {
  yield put(Router.push({ search: '' }));
}

const isWhitelistedIPCreated = (action: Action) =>
  action.type === Types.CREATE_COMPLETED && action.service === Service.Campaigns;

export function* whitelistSaga() {
  yield takeEvery(isWhitelistedIPCreated, hideNewIPModal);
}
